var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"g2-s"},_vm._l((_vm.list),function(el,i){return _c('Col',{key:i,attrs:{"span":_vm.colSpan}},[_c('div',{staticClass:"g2-s-name"},[_vm._v(_vm._s(el.name))]),_vm._v(" "),_c('div',{staticClass:"g2-s-money"},[_vm._v(_vm._s(el.value))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bf853e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../projectCore/src/components/g2-chart/src/statistic.vue
// module id = null
// module chunks = 